"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseDialogs = require("nicbase-dialogs");

var _nicbaseForms = require("nicbase-forms");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseTranslation = require("nicbase-translation");

var _report = _interopRequireDefault(require("./report"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ALL = 'ALL';

var ReportExportDialog = function ReportExportDialog(_ref) {
  var _tourProps$segments;

  var isActive = _ref.isActive,
      onSave = _ref.onSave,
      onCancel = _ref.onCancel,
      tourProps = _ref.tour;
  var intl = (0, _nicbaseTranslation.useIntl)();

  var _useUser = (0, _nicbaseReducers.useUser)(),
      email = _useUser.email;

  var _useState = (0, _react.useState)(_objectSpread(_objectSpread({}, tourProps), {}, {
    report: _objectSpread(_objectSpread({}, tourProps.report), {}, {
      showGeoInformation: false,
      recipients: [email],
      shareViaEmail: true,
      uploadAsIdocFormat: false
    }),
    segments: tourProps === null || tourProps === void 0 ? void 0 : (_tourProps$segments = tourProps.segments) === null || _tourProps$segments === void 0 ? void 0 : _tourProps$segments.map(function (segment) {
      return _objectSpread(_objectSpread({}, segment), {}, {
        report: {
          showGeoInformation: false,
          recipients: [email],
          shareViaEmail: true,
          uploadAsIdocFormat: false
        }
      });
    })
  })),
      _useState2 = _slicedToArray(_useState, 2),
      tour = _useState2[0],
      setTour = _useState2[1];

  var defaultReport = {
    token: tour.token,
    report: tour.report
  };

  var _useState3 = (0, _react.useState)(defaultReport),
      _useState4 = _slicedToArray(_useState3, 2),
      report = _useState4[0],
      setReport = _useState4[1];

  var allSections = {
    value: ALL,
    label: intl.formatMessage({
      id: 'widgets.tourBoard.tourReport.allSections'
    })
  };

  var _useState5 = (0, _react.useState)(allSections.value),
      _useState6 = _slicedToArray(_useState5, 2),
      section = _useState6[0],
      setSection = _useState6[1];

  var source = (0, _react.useMemo)(function () {
    var _tour$segments;

    return [allSections].concat(_toConsumableArray((_tour$segments = tour.segments) === null || _tour$segments === void 0 ? void 0 : _tour$segments.map(function (segment, index) {
      var _tour$wayPoints$segme, _tour$wayPoints$segme2;

      return {
        value: index,
        label: "".concat(index + 1, ". ").concat((_tour$wayPoints$segme = tour.wayPoints[segment.validityWayPointIndexRange[0]]) === null || _tour$wayPoints$segme === void 0 ? void 0 : _tour$wayPoints$segme.poiName, " - ").concat((_tour$wayPoints$segme2 = tour.wayPoints[segment.validityWayPointIndexRange[segment.validityWayPointIndexRange.length - 1]]) === null || _tour$wayPoints$segme2 === void 0 ? void 0 : _tour$wayPoints$segme2.poiName)
      };
    })));
  }, [allSections, tour.segments, tour.wayPoints]);

  var onUpdateTourProperty = function onUpdateTourProperty(updatedTourProperties) {
    if (section === ALL) {
      setTour(function (prev) {
        return _objectSpread(_objectSpread({}, prev), updatedTourProperties);
      });
      setReport(_objectSpread({
        token: tour.token
      }, updatedTourProperties));
    } else {
      var _tour$segments$sectio;

      var newSegments = [].concat(_toConsumableArray(tour.segments.slice(0, section)), [_objectSpread(_objectSpread({}, tour.segments[section]), updatedTourProperties)], _toConsumableArray(tour.segments.slice(section + 1)));
      setReport(_objectSpread({
        token: (_tour$segments$sectio = tour.segments[section]) === null || _tour$segments$sectio === void 0 ? void 0 : _tour$segments$sectio.token
      }, updatedTourProperties));
      setTour(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          segments: newSegments
        });
      });
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.BasisDialog, {
    active: isActive,
    title: /*#__PURE__*/_react["default"].createElement("span", {
      className: "dialog-title-container"
    }, intl.formatMessage({
      id: 'widgets.tourBoard.tourReport'
    })),
    content: /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-left p-32"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Dropdown, {
      label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "widgets.tourBoard.tourReport.label"
      }),
      source: source,
      value: section,
      onChange: function onChange(index) {
        setSection(index);

        if (index === ALL) {
          setReport(defaultReport);
        } else {
          var _tour$segments$index;

          setReport({
            token: (_tour$segments$index = tour.segments[index]) === null || _tour$segments$index === void 0 ? void 0 : _tour$segments$index.token,
            report: _objectSpread({}, tour.segments[index].report)
          });
        }
      }
    }), /*#__PURE__*/_react["default"].createElement(_report["default"], {
      tour: section === ALL ? tour : tour.segments[section],
      onUpdateTourProperty: onUpdateTourProperty
    })),
    actions: [/*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
      primary: true,
      onClick: onCancel
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "common.cancel"
    })), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
      primary: true,
      raised: true,
      className: "ml-3",
      onClick: function onClick() {
        return onSave(report);
      },
      disabled: tour.report.shareViaEmail && tour.report.recipients.length === 0
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.requestReport"
    }))],
    onRequestCancel: onCancel,
    onRequestClose: onCancel
  });
};

var noop = function noop() {};

ReportExportDialog.propTypes = {
  isActive: _propTypes["default"].bool.isRequired,
  onSave: _propTypes["default"].func,
  onCancel: _propTypes["default"].func,
  tour: _propTypes["default"].shape({
    report: _propTypes["default"].shape({
      recipients: _propTypes["default"].arrayOf(_propTypes["default"].string)
    }),
    token: _propTypes["default"].string,
    route: _propTypes["default"].shape(),
    sharedWithPortals: _propTypes["default"].shape(),
    wayPoints: _propTypes["default"].shape(),
    segments: _propTypes["default"].arrayOf(_propTypes["default"].shape())
  }).isRequired
};
ReportExportDialog.defaultProps = {
  onSave: noop,
  onCancel: noop
};
var _default = ReportExportDialog;
exports["default"] = _default;